import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import './NotFound.css';
import Zen from './Lottie';


export default function NotFound() {
  return (
    <div className="NotFoundContainer">
      <div className="NotFoundLogo">
        <img style={{ width: '100%' }} src={process.env.PUBLIC_URL + '/logoZenHQ.png'} />
      </div>

      <div className="NotFoundText">
        <p className="NotFoundP">Oops, we couldn't find what you're looking for!</p>
        <h1>Enjoy this zen space</h1>
        <Zen />
        <p>And take a breath, before you </p>
        <Link to="/" className="DashboardLink">
          <Button style={{ backgroundColor: 'white', margin: '1rem', color: '#666666' }}>
            go back to dashboard
          </Button>
        </Link>
      </div>

    </div >
  )
};